import React from 'react';
import { Feature, InjectorService, ToolbarService } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import TransitionPreviewPanel from '@com-pc/transition-preview-panel';
import { ITransitionService } from '@src/slide/application/service/transition-service/transition-service-interface';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';

@Feature()
export class TransitionPreviewFeature extends BaseToolbarFeature {
    public toolbarService: ToolbarService;
    public id = config.id;
    public config = config;
    private transitionServiceInstance: ITransitionService;

    public constructor() {
        super();
        this.toolbarService = InjectorService.get(ToolbarService);
    }

    public handlePreview = () => {
        this.getTransitionService()?.then(() => {
            this.transitionServiceInstance.preview();
        });
    };

    public handleAutoPreview = () => {
        this.getTransitionService()?.then(() => {
            this.transitionServiceInstance.toggleAutoPreview();
        });
    };

    public getDropdownContent() {
        this.getTransitionService();

        return <TransitionPreviewPanel
            handlePreview={this.handlePreview}
            handleAutoPreview={this.handleAutoPreview}
            isAutoChosen={!!this.transitionServiceInstance?.autoPreviewState}
        />;
    }

    public getCustomDisabledState() {
        return this.shouldDisablePreview();
    }

    public shouldDisablePreview(): boolean {
        return !this.currentSlideTransition || this.currentSlideTransition?.type === TransitionType.EMPTY;
    }

    private get currentSlide() {
        return this.getAppService().viewableServiceLayer.selectionService.currentSlide;
    }

    private get currentSlideTransition() {
        return this.currentSlide?.transition;
    }

    private getTransitionService() {
        return this.getAppService().editableServiceLayer?.transitionService?.promise().then((module) => {
            if (!this.transitionServiceInstance) {
                this.transitionServiceInstance = module;
                this.toolbarService.$forceUpdate();
            }
        });
    }
}
